import React from "react"
import PropTypes from "prop-types"

// Utilities
import kebabCase from "lodash/kebabCase"
import AniLink from "gatsby-plugin-transition-link/AniLink"

// Components
import { Helmet } from "react-helmet"
import { graphql } from "gatsby"
import LooseFooter from "../components/layout/LooseFooter"
import { SEO } from 'gatsby-theme-seo'
import DuoNav from "../components/duoNav"

const TagsPage = ({
  data: {
    allContentfulBlogPost: { group },
    site: {
      siteMetadata: { title },
    },
  },
}) => (
  <div className="h-screen">
  <div className="container mx-auto h-80/100">
    <SEO title="Tags" />
    <div className="w-full h-full py-24 flex flex-wrap content-center px-6 lg:px-0">
      <h1 className="text-xl lg:text-5xl w-full">Tags disponíveis</h1>
      <p className="font-light tracking-wide w-full">Navegue entre as tags de nosso blog</p>
      <ul className="mt-12">
        {group.map(tag => (
          <li key={tag.fieldValue}
            className={`
            lg:inline 
            lg:p-2
            px-1
            mr-2
            rounded 
            mb-1
            lg:mb-0
            text-sm
            inline-block
            lg:text-base 
            font-light
            capitalize  
            
            text-gray-700 
            hover:text-criptoBlue-700 

            bg-gray-300 
            hover:bg-criptoBlue-200                     
            
            border-b-2 
            border-r-2 
            border-gray-400
            hover:border-criptoBlue-400
            
            hover:shadow-md
            
          `}
          >
            <AniLink 
              swipe
              direction="down"
              top="exit"
              to={`/tags/${kebabCase(tag.fieldValue)}/`}>
              {tag.fieldValue} ({tag.totalCount})
            </AniLink>
            
          </li>
        ))}
      </ul>
      <DuoNav left="autores" right="categorias" />
    </div>
  </div>
  <LooseFooter />
  </div>
)

TagsPage.propTypes = {
  data: PropTypes.shape({
    allContentfulBlogPost: PropTypes.shape({
      group: PropTypes.arrayOf(
        PropTypes.shape({
          fieldValue: PropTypes.string.isRequired,
          totalCount: PropTypes.number.isRequired,
        }).isRequired
      ),
    }),
    site: PropTypes.shape({
      siteMetadata: PropTypes.shape({
        title: PropTypes.string.isRequired,
      }),
    }),
  }),
}

export default TagsPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    allContentfulBlogPost(limit: 200) {
      group(field: tags) {
        fieldValue
        totalCount
      }
    }
  }
`